import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { AddEditLeadComponent } from './components/add-edit-lead/add-edit-lead.component';
import { UsersSharedModule } from '@features/users/shared/users-shared.module';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { EmojiFlagPipe } from '@shared/filters/emoji-flag.pipe';
import { RouterModule } from '@angular/router';
import { MomentModule } from 'ngx-moment';
import * as fromLeads from './reducers/leads.reducer';
import { StoreModule } from '@ngrx/store';
import { LeadCustomerSelectorComponent } from './components/lead-customer-selector/lead-customer-selector.component';
import { LeadCustomerSelectorItemComponent } from './components/lead-customer-selector-item/lead-customer-selector-item.component';
import { CreateLeadCustomerComponent } from './components/create-lead-customer/create-lead-customer.component';
import { LeadSourceTagsModule } from '@features/lead-source-tags/lead-source-tags.module';
import { CustomersSharedModule } from '@features/customers/shared/customers-shared.module';
import { LeadSourceSelectorComponent } from '../components/lead-source-selector/lead-source-selector.component';

@NgModule({
  declarations: [
    AddEditLeadComponent,
    LeadCustomerSelectorComponent,
    LeadCustomerSelectorItemComponent,
    CreateLeadCustomerComponent,
    LeadSourceSelectorComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    UsersSharedModule,
    NgxMaskPipe,
    NgxMaskDirective,
    EmojiFlagPipe,
    RouterModule,
    MomentModule,
    LeadSourceTagsModule,
    CustomersSharedModule,
    StoreModule.forFeature(fromLeads.featureKey, fromLeads.reducer),
  ],
  exports: [AddEditLeadComponent],
})
export class LeadsSharedModule {}
